
import React, { FC, memo, useState, useEffect, useMemo } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import { LotScreenSettings } from "../config/uiconfig";
import store from "../store";
import GiaThuongItem from "./giaThuongItem";
import { LotContact } from "./type";
import { checkAllTienHoi, fetchContactGiaThuong, postContactAllInfo, updateBatchGiaThuong, updateContactData, updateGiaThuongMienBac, updateGiaThuongMienNam, updateGiaThuongMienTrung, updateHanMucJson } from "../redux/contactsSlice";
import _ from 'lodash'
import Spinner from "../../ui/Spinner";
import Avatar from "../../common/Avatar";
import TabList from "../../ui/TabList";
import InputText from "../../ui/InputText";
import ContactsConfig from "./contactsConfig";
import CollapseGroup from '../ui/collapse'
import LotLoading from "../ui/loading";
import Select from "../../ui/Select";
import { ChangeEvent } from "react";
import LotSpinner from "../ui/LotSpinner";
import MySnackbar from "../ui/mySnackbar";
import Snackbar from "../ui/snackbar";
import hideKeyboard from "../ui/hideKeyboard";
import { updateLastScreen } from "../redux/loginSlice";
import ParserSettings from "./parserSettings";
import { GetLineFromGia, isCuPhapMb, isCuPhapMn } from "../utils/common";
import HanMuc from "./hanmuc";
import Checkbox from "../../ui/Checkbox";
import MessageEditor from "../message/messageEditor";
import Parser from "../restapi/parser";
import { ContactsApi } from "../restapi/contactsApi";
import Menu from "../../ui/Menu";
import DropdownMenu from "../../ui/DropdownMenu";
import MenuItem from "../../ui/MenuItem";
import ConfirmDialog from "../../ui/ConfirmDialog";
import Decimal from "decimal.js";

export type OwnProps = {
    onChangeScreen: (screen: LotScreenSettings) => void;
    contact?: LotContact
};
type MenuItem = 'DatThamSo' | 'ResetDefault';
type tabProps = {
    onDataChange: () => void;
    props: any;
    curContact: any;
    localStore: any;
    onMenuClick: (menuItem: MenuItem) => void;
}
const RenderTabContent: FC<tabProps> = ({
    onDataChange,
    props,
    curContact,
    localStore,
    onMenuClick,
}) => {
    let giaThuongList: any = [];
    const [state, setState] = useState({
        activeTab: 0, // giá thưởng/hạn mức/ hạn mức chung
        errorTextToUser: '',
        htmlError: '',
        rawText: '',
        hanMucJson: '',
        hienThiSoGiai: false,
    })
    const setting_index = isCuPhapMn() ? 4 : 3
    const hanMuc_index = isCuPhapMn() ? 4 : 2
    function handleContactDataChange(fieldName: string, value: any) {
        const payload = { fieldName: fieldName, value: value }
        store.dispatch(updateContactData(payload))
        onDataChange ? onDataChange() : undefined
    }
    function handleGiaThuongChange(index: number, mienDaiCuocId: number, fieldName: string, value: any) {
        //mienDaiCuocId dựa vào đây biết lấy dữ liệu ở mảng nào trong store, key là index rồi

        const payload = { index: index, mienDaiCuocId: mienDaiCuocId, fieldName: fieldName, value: value }
        console.log(`Gia thuong changed `, payload)
        switch (mienDaiCuocId) {
            case 1: // miền bắc
                store.dispatch(updateGiaThuongMienBac(payload))
                break;
            case 2: // miền bắc
                store.dispatch(updateGiaThuongMienTrung(payload))
                break;
            case 3:
                store.dispatch(updateGiaThuongMienNam(payload))
                break;
        }
        onDataChange ? onDataChange() : undefined
    }

    switch (props.activeTab) {
        case 0: // thông tin chính
            return (<div style="padding:1rem 1rem 0 1rem ;overflow-y:auto;height:80%;">

                <InputText label={"Tên" + ' (id:' + curContact.contactId + ")"} value={curContact.name}
                    onChange={(e) => { handleContactDataChange("name", e.target.value) }}

                />
                <Select label="Vai trò"
                    id="contact-select-role"
                    value={curContact.tinhId}
                    className=""
                    onChange={(e) => {
                        handleContactDataChange("role", Number(e.target.value));
                    }}
                >
                    {
                        ['Khách', 'Chủ', 'Khách và chủ'].map((item: any, index) => {
                            const role = index + 1
                            return <option value={role} selected={curContact.role == role} >{item}</option>
                        })
                    }
                </Select>
                <InputText label="Số điện thoại" value={curContact.phone}
                    onChange={(e) => { handleContactDataChange("phone", e.target.value) }}
                />
                <InputText label="Xưng hô ngôi 1" value={curContact.ngoi1}
                    onChange={(e) => { handleContactDataChange("ngoi1", e.target.value) }}
                />
                <InputText label="Xưng hô ngôi 2" value={curContact.ngoi2}
                    onChange={(e) => { handleContactDataChange("ngoi2", e.target.value) }}
                />
                <InputText label="ID Telegram" value={curContact.tlUserId}
                    onChange={(e) => {
                        const id = Number(e.target.value)
                        if (!isNaN(id))
                            handleContactDataChange("tlUserId", id)
                    }}
                />
                <InputText label="ID Telegram trả lại" value={curContact.botTraId}
                    onChange={(e) => {
                        const id = Number(e.target.value)
                        if (!isNaN(id))
                            handleContactDataChange("botTraId", id)
                    }}
                />
                <InputText label="% thầu lại" value={curContact.phanTramThau} inputMode="numeric"
                    onChange={(e) => {
                        const ptThau = Number(e.target.value)
                        if (!isNaN(ptThau))
                            handleContactDataChange("phanTramThau", ptThau)
                    }}
                />
                <Select label="Khi phân tích, dùng cấu hình của tỉnh/TP"
                    id="contact-select-tinh-tp"
                    value={curContact.tinhId}
                    className=""
                    onChange={(e) => {
                        handleContactDataChange("tinhId", e.target.value);
                    }}
                >
                    {
                        localStore.contact.dmTinh.map((item: any) => {
                            return <option value={item.tinhId} selected={curContact.tinhId == item.tinhId} >{item.tenTinh}</option>
                        })
                    }
                </Select>


                <>
                    <Checkbox label="Tự động phân tích tin" checked={curContact.autoPhanTich == 1}
                        subLabel="Tin nhắn telegram đến và đi được tự động phân tích (Cơ chế bot)"
                        onChange={(e) => {
                            handleContactDataChange("autoPhanTich", e.target.checked ? 1 : 0);
                        }}></Checkbox>
                    <Checkbox label="Tự động báo lỗi" checked={curContact.autoBaoLoi == 1}
                        subLabel="Tự động phân tích lỗi, sẽ tự động gửi thông báo lỗi tới khách hàng"
                        onChange={(e) => {
                            handleContactDataChange("autoBaoLoi", e.target.checked ? 1 : 0);
                        }}></Checkbox>
                    <Checkbox label="Tự động OK sau khi phân tích" checked={curContact.autoOk == 1}
                        subLabel="Sau khi phân tích tin nhắn, tự động gửi tin OK qua telegram"
                        onChange={(e) => {
                            handleContactDataChange("autoOk", e.target.checked ? 1 : 0);
                        }}></Checkbox>
                    <Checkbox label="Tự động trả lại số vượt" checked={curContact.traLaiSoVuot == 1}
                        subLabel="Các số lớn hơn ngưỡng cho phép sẽ tự động gửi tin trả lại qua telegram"
                        onChange={(e) => {
                            handleContactDataChange("traLaiSoVuot", e.target.checked ? 1 : 0);
                        }}></Checkbox>
                    <Checkbox label="Tự động trả lại tin quá giờ" checked={curContact.traLaiTinQuaGio == 1}
                        subLabel="Tin nhắn quá giờ cho phép sẽ trả lại cả tin qua Telegram"
                        onChange={(e) => {
                            handleContactDataChange("traLaiTinQuaGio", e.target.checked ? 1 : 0);
                        }}></Checkbox>
                    <Checkbox label="Tự động cân chuyển vào liên lạc này (Bot @loto88sendbot)" checked={curContact.desTeleChatId == 1}
                        subLabel="Số liệu vượt giới hạn giữ lại sẽ tự động được bot gửi cho liên hệ này qua telegram, bạn chỉ có thể thiết lập duy nhất 1 liên lạc cho tài khoản của bạn, bot phải là thành viên nhóm của bạn"
                        onChange={(e) => {
                            handleContactDataChange("desTeleChatId", e.target.checked ? 1 : 0);
                        }}></Checkbox>
                </>

            </div>
            )
            break;
        case setting_index:
            return <ContactsConfig tinhId={localStore.contact.currentContact.tinhId}

                onDataChange={onDataChange}

            />
        case 1: // giá miền bắc
            giaThuongList = store.getState().contact.contactGiaThuongArrMB
            break;
        case 2:
            if (isCuPhapMn())
                giaThuongList = store.getState().contact.contactGiaThuongArrMT
            else {
                giaThuongList = store.getState().contact.contactGiaThuongArrMB
                return <HanMuc giaThuongList={giaThuongList} />
            }
            break;
        case 3:
            giaThuongList = store.getState().contact.contactGiaThuongArrMN
            break;


    }
    function handleCheckAll() {
        let mien = props.activeTab;

        store.dispatch(checkAllTienHoi({ mien: mien }))
    }
    const renderTienHoi = () => {
        let mien = props.activeTab;

        let phanTram = curContact.phanTramMb
        let nguongHoi = curContact.nguongHoiMb
        let filedNamePt = "phanTramMb"
        let filedNameNguong = "nguongHoiMb"
        switch (mien) {
            case 1:
                phanTram = curContact.phanTramMb
                nguongHoi = curContact.nguongHoiMb
                break;
            case 2:
                phanTram = curContact.phanTramMt
                nguongHoi = curContact.nguongHoiMt
                filedNamePt = "phanTramMt"
                filedNameNguong = "nguongHoiMt"
                break;
            case 3:
                phanTram = curContact.phanTramMn
                nguongHoi = curContact.nguongHoiMn
                filedNamePt = "phanTramMn"
                filedNameNguong = "nguongHoiMn"
                break;
        }
        return (<div className='hoi-item-container'>
            <div style="padding:15px 15px 0 15px ;display:flex;flex-direction:row; justify-content:space-between">
                <InputText label='% Hồi' inputMode='decimal' value={phanTram}
                    onChange={(e) => {
                        const value = Number(e.target.value.replace(",", "."));
                        if (!isNaN(value)) {
                            handleContactDataChange(filedNamePt, value);
                        }
                    }
                    }
                    className='text-input '></InputText>
                <div style="width:20px;"></div>
                <InputText label='Hồi khi lời lớn hơn' inputMode='decimal' value={nguongHoi}
                    onChange={(e) => {
                        const value = Number(e.target.value.replace(",", "."));
                        if (!isNaN(value)) {
                            handleContactDataChange(filedNameNguong, value);
                        }
                    }
                    }
                    className='text-input '></InputText>
                <Button round
                    size="smaller"
                    color="translucent"
                    onClick={handleCheckAll}
                >
                    <i className="fa-solid fa-list-check"></i>
                </Button>
                <div style="z-index:1001">
                    <DropdownMenu
                        positionX="right">
                        <MenuItem
                            onClick={() => {
                                if (onMenuClick) {
                                    onMenuClick("DatThamSo")
                                }
                            }}>
                            Đặt tham số hàng loạt
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                setState(prev => ({ ...prev, hienThiSoGiai: !prev.hienThiSoGiai }))
                            }}>
                            {state.hienThiSoGiai ? "Ẩn số giải" : "Hiển thị số giải"}
                        </MenuItem>
                    </DropdownMenu>
                </div>
            </div>
        </div>)
    }
    const tabsMb = [
        { type: 'giá, thưởng', title: 'giá, thưởng' },
        { type: 'hạn mức', title: 'Hạn mức' },
    ];
    const tabsMtMn = [
        { type: 'giá, thưởng', title: 'giá, thưởng' },
        { type: 'hạn mức', title: 'Hạn mức' },
        { type: 'hạn mức', title: 'Hạn mức chung' },
    ];
    function handleTextChange(html: string, rawText: string) {
        setState(prev => ({ ...prev, rawText: rawText }))
    }
    async function handleParseMessage() {
        const currentContact: any = store.getState()?.contact?.currentContact
        const contactId = currentContact.contactId
        const payload = {
            body: state.rawText,
            date: store.getState().global.workDate,
            time: "00:00:59",
            type: 1,
            contactId: contactId,
            mien: "NAM",
            curMien: "NAM",
            getCompactData: 1,
            getRawData: 0,
            mienCuPhapId: isCuPhapMb() ? 1 : 2,
            tachXienMay: 3,
            soBoSo: 10,
            lockArea: 0,
        }
        if (isCuPhapMb()) {
            payload.mien = "BAC"
            payload.curMien = "BAC"
        }
        let result = await Parser.parseCanChuyenMessage(payload)
        let html = result.data.html
        if (html == "")
            html = result.data.bodyViet
        setState(prev => ({ ...prev, htmlError: html, errorTextToUser: result.responseText }))
        if (result.data.parseStatus == "parseOK") {
            const payload = {
                contactId: contactId,
                JSON: JSON.stringify(result.data.compactData),
                hanMucText: state.rawText,
            }
            ContactsApi.saveHanMucJson(payload).then(ret => {
                console.log(ret)
            })
            const hanMucJsonArr = store.getState().contact.hanMucJson
            let hanMuc = { contactId: contactId, hanMucText: state.rawText, json: JSON.stringify(result.data.compactData) }
            store.dispatch(updateHanMucJson({ hanMucJson: hanMuc, contactId: contactId }))

        }
    }
    useEffect(() => {
        if (isCuPhapMb())
            return;
        let hanMucJsonArr: any = store.getState().contact.hanMucJson
        const contact: any = store.getState().contact.currentContact
        const contactId = contact.contactId
        let hanMuc = hanMucJsonArr[contactId + ""]
        if (hanMuc == undefined) {
            const data = ContactsApi.getHanMucJson(contactId).then((result) => {
                const data = result.data
                hanMuc = data
                if (hanMuc.contactId == 0) { // chưa có bản ghi nào
                    hanMuc.contactId = contactId
                }

                const payload = { contactId: contactId, hanMucJson: hanMuc }
                store.dispatch(updateHanMucJson(payload))
                setState(prev => ({
                    ...prev, hanMucJson: hanMuc, htmlError: hanMuc.hanMucText, rawText: hanMuc.hanMucText,
                    isLoading: false
                }))
            })
        }
        else {
            setState(prev => ({
                ...prev, hanMucJson: hanMuc, htmlError: hanMuc.hanMucText, rawText: hanMuc.hanMucText
                , isLoading: false
            }))

        }
    }, [])
    useEffect(() => {
        if (props.activeTab == 1) { // tab MB
            if (state.activeTab == 2) {
                setState(prev => ({ ...prev, activeTab: 1 }))
            }
        }
    }, [props.activeTab])
    function handleSaveDataApplyAll() {
        hideKeyboard()
        store.dispatch(postContactAllInfo({ applyAll: 1, contactId: curContact.contactId }))
    }

    // render giá, thưởng với data đã được chọn
    return (
        <div className="gia-thuong-list-item">
            <div>
                {/*MB*/}
                {(props.activeTab == 1 || props.activeTab == 2 || props.activeTab == 3) && isCuPhapMn() && renderTienHoi()}
            </div>
            {isCuPhapMn() &&

                props.activeTab == 1
                ? <div style={"position:sticky;top:0; background-color:white;z-index:1000;"}>
                    <TabList tabs={tabsMb} activeTab={state.activeTab} onSwitchTab={(index) => { setState((prev) => ({ ...prev, activeTab: index })) }}></TabList>
                </div>
                : <div style={"position:sticky;top:0; background-color:white;z-index:1000;"}>
                    <TabList tabs={tabsMtMn} activeTab={state.activeTab} onSwitchTab={(index) => { setState((prev) => ({ ...prev, activeTab: index })) }}></TabList>
                </div>
            }
            <div>
                {/* đài  miền trong props.activeTab=2,3 */}
                {
                    ((props.activeTab == 2 || props.activeTab == 3) && state.activeTab == 2) && <div className="common-container-row padding-top">
                        <Button
                            onClick={handleSaveDataApplyAll}>Áp dụng cả tuần</Button>
                    </div>
                }
                {

                    giaThuongList.length > 0 ? giaThuongList.map((item: any, index: any) => {
                        return (<GiaThuongItem
                            loaiCuocId={item.loaiCuocId}
                            index={index}
                            gia={item.gia}
                            mienDaiCuocId={item.mienDaiCuocId}
                            thuong={item.hsthuong}
                            soGiai={item.soGiai}
                            maxSoNhayThuong={item.maxSoNhayThuong}
                            hoi={item.hoi}
                            onChange={handleGiaThuongChange}
                            nhanMax={item.nhanMax}
                            chuyenMax={item.chuyenMax}
                            khAn={item.khAn}
                            tuAn={item.tuAn}
                            activeTab={state.activeTab}
                            showSoGiai={state.hienThiSoGiai}

                        />)
                    }) : (<Spinner className="center-item" />)


                }
            </div>
            {state.activeTab == 1 &&
                <div>
                    <MessageEditor msgType={1}
                        onTextChange={handleTextChange}
                        maxHeight="5rem"
                        hidenFontSizeSetting={false}
                        htmlError={state.htmlError}
                        errorTextToUser={state.errorTextToUser}
                        showSaveButton
                        onParseMessage={handleParseMessage}
                    ></MessageEditor>
                </div>}
            {/* <Spinner className="center-item"/> */}
        </div>
    )
}

const EditContact: FC<OwnProps> = ({
    onChangeScreen,
    contact
}) => {
    const localStore = store.getState();
    const globalStore = store;
    const TABS = isCuPhapMn() ? [
        { type: 'info', title: 'Liên lạc' },
        { type: 'abc', title: 'Đài MB' },
        { type: 'documents', title: 'Đài MT' },
        { type: 'links', title: 'Đài MN' },
        { type: 'links', title: 'Cài đặt' },

    ] : [
        { type: 'info', title: 'Liên lạc' },
        { type: 'abc', title: 'Giá, thưởng' },
        { type: 'abc', title: 'Hạn mức' },
        { type: 'links', title: 'Cài đặt' },

    ];
    const tabsrow0 = useMemo(() => ([
        ...TABS,
    ]), [/* hasCommonChatsTab, hasMembersTab, isChannel, topicId */]);

    const [state, setState] = useState({
        isLoading: true,
        isSaving: false,
        activeTab: 0,
        isDataChanged: false,
        showSnackbar: false,
        snackbarMessage: "",
        setAllParamOpen: false,

        setGiaThuong: {
            giaDaT: 0.755,
            thuongDaT: 750,
            giaDaX: 0.755,
            thuongDaX: 550,
            gia2C: 0.75,
            thuong2C: 75,
            gia3C: 0.65,
            thuong3C: 650,
            gia4C: 0.65,
            thuong4C: 5500,
        }
    })
    const curContact = store.getState().contact.currentContact
    //Lưu lại màn hình này, nếu vào trong sẽ quay lại đây
    useEffect(() => {
        store.dispatch(updateLastScreen(LotScreenSettings.EDIT_CONTACT_SCREEN))
    }, [])
    useEffect(() => {
        const currentContactId = curContact ? curContact.contactId : 0
        const payload = [currentContactId, 2, store.getState().global.workDate]
        store.dispatch(fetchContactGiaThuong(payload))
    }, [])
    const obserStore = () => {
        const loaded = !store.getState().contact.isLoading
        if (loaded) {
            setState((prev) => ({ ...prev, isLoading: false, }))
        }
        const saving = store.getState().contact.isSaving
        setState((prev) => {
            if (prev.isSaving && !saving) { // đang lưu=true, lưu xong = false
                const response = store.getState().contact.postContactAllInfoResponse
                return {
                    ...prev, isSaving: saving, isDataChanged: false,
                    showSnackbar: true,
                    snackbarMessage: response.responseText,
                }
            }
            else
                return { ...prev, isSaving: saving }
        })
    }
    useEffect(() => {
        const unsubscribe = store.subscribe(obserStore)
        return unsubscribe
    }, [])


    function handleSubDataChange() {
        setState({ ...state, isDataChanged: true })
    }
    function handleSaveData() {
        hideKeyboard()
        store.dispatch(postContactAllInfo({ applyAll: 0, contactId: curContact.contactId }))
    }
    function handleMenuClick(menuItem: MenuItem) {
        switch (menuItem) {
            case 'DatThamSo':
                setState(prev => ({ ...prev, setAllParamOpen: true }))
                break;
        }
    }
    function getTitleDatThamSo() {
        let tmp = 'tham so';
        switch (state.activeTab) {
            case 1:
                tmp = 'Đài MB';
                break;
            case 2:
                tmp = 'Đài MT';
                break;
            case 3:
                tmp = 'Đài MN';
                break;
        }
        return tmp
    }
    function IsRenderLine(): boolean {
        return curContact!.tinhId == "BTH";
    }
    function getGiaDisplay(gia: number): number {
        if (IsRenderLine())
            return GetLineFromGia(gia)
        else return gia
    }
    function getValueInLineOrGia(gia: number, line: boolean): number {
        /* if (!line) {
            return gia;
        }
        let tmp = new Decimal(gia);  // Tạo một đối tượng Decimal với giá trị 100
        tmp = new Decimal(100).minus(tmp).div(100);  // Tính toán (100 - value) / 100
        const result = Number(tmp.toString())
        console.log('gia:',gia, 'line:',result) */
        return gia
    }
    function getGiaFromLine(gia: number, line: boolean): number {
        if (!line) {
            return gia;
        }
        let tmp = new Decimal(gia);  // Tạo một đối tượng Decimal với giá trị 100
        tmp = new Decimal(100).minus(tmp).div(100);  // Tính toán (100 - value) / 100
        const result = Number(tmp.toString())
        console.log('gia:', gia, 'line:', result)
        return result
    }
    return (
        <div className="edit-contact-main" >
            <div className="edit-contact-header">
                <div className="left-panel">
                    <Button
                        round
                        size="default"
                        color="translucent"
                        onClick={() => onChangeScreen(LotScreenSettings.CONTACT_LIST_SCREEN)}
                    //className={buildClassName(styles.headerButton, styles.firstButton)}
                    //ariaLabel={lang(isFullscreen ? 'AccExitFullscreen' : 'AccSwitchToFullscreen')}
                    >
                        <i
                            className='icon icon-arrow-left'
                            aria-hidden
                        />
                    </Button>
                    <Avatar
                        //photo={notPersonalPhoto}
                        noPersonalPhoto
                        //peer={user}
                        text={curContact ? curContact.name : ""}
                        size="small"
                        className="personal-photo"
                    />
                    <div className="divider"></div>
                    {curContact ? curContact.name : ""}
                </div>
                {!state.isSaving &&
                    <Button round
                        onClick={handleSaveData}
                        size="default"
                        color="translucent" >
                        <i className={state.isDataChanged ? "fa-regular fa-floppy-disk  fa-xl fa-beat" : "fa-regular fa-floppy-disk  fa-xl"}></i>
                    </Button>
                }
                {
                    state.isSaving && <div style="padding:0 0.75rem 0 0"> <LotSpinner /> </div>
                }
            </div>
            <TabList tabs={tabsrow0} activeTab={state.activeTab} onSwitchTab={(index) => { setState((prev) => ({ ...prev, activeTab: index })) }}></TabList>
            {state.isLoading && <LotLoading />}
            {!state.isLoading && <RenderTabContent
                props={state}
                curContact={curContact}
                localStore={localStore}
                tinhId={store.getState().login.tinhId}
                onMenuClick={handleMenuClick}
                onDataChange={handleSubDataChange} />}
            <Snackbar isOpen={state.showSnackbar} message={state.snackbarMessage} triggerTime={Date()}
                onClose={() => { setState((prev) => ({ ...prev, showSnackbar: false })) }}
            />
            <ConfirmDialog
                title={getTitleDatThamSo()}
                confirmLabel="Áp dụng"
                isOnlyConfirm={false}
                isOpen={state.setAllParamOpen}
                confirmHandler={() => {
                    let mien = '';
                    switch (state.activeTab) {
                        case 1:
                            mien = 'MB';
                            break;
                        case 2:
                            mien = 'MT';
                            break;
                        case 3:
                            mien = 'MN';
                            break;
                    }
                    const payload = { mien: mien, value: state.setGiaThuong, line: IsRenderLine() }
                    store.dispatch(updateBatchGiaThuong(payload))
                    setState(prev => ({ ...prev, setAllParamOpen: false }))
                }}
                onClose={() => {
                    setState(prev => ({ ...prev, setAllParamOpen: false }))
                }}>
                <div className=" common-container-row center grid">
                    <div className=" label-left-of-input">Đá thẳng</div>
                    <InputText label={IsRenderLine() ? "Line" : "Giá"}
                        onChange={(e) => {
                            const line = IsRenderLine()
                            let value = getValueInLineOrGia(Number(e.target.value), line);
                            if (!isNaN(value)) {
                                value = getGiaFromLine(value, line)
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, giaDaT: value } }))
                            }
                        }}
                        value={getGiaDisplay(state.setGiaThuong.giaDaT)}></InputText>
                    <InputText label="Thưởng"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            if (!isNaN(value))
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, thuongDaT: value } }))
                        }}
                        value={state.setGiaThuong.thuongDaT}></InputText>
                </div>
                <div className=" common-container-row center grid">
                    <div className=" label-left-of-input">Đá xiên</div>
                    <InputText label={IsRenderLine() ? "Line" : "Giá"}
                        onChange={(e) => {
                            const line = IsRenderLine()
                            let value = getValueInLineOrGia(Number(e.target.value), line);
                            if (!isNaN(value)) {
                                value = getGiaFromLine(value, line)
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, giaDaX: value } }))
                            }
                        }}
                        value={getGiaDisplay(state.setGiaThuong.giaDaX)}></InputText>
                    <InputText label="Thưởng"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            if (!isNaN(value))
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, thuongDaX: value } }))
                        }}
                        value={state.setGiaThuong.thuongDaX}></InputText>
                </div>
                <div className=" common-container-row center grid">
                    <div className=" label-left-of-input">2 con</div>
                    <InputText label={IsRenderLine() ? "Line" : "Giá"}
                        onChange={(e) => {
                            const line = IsRenderLine()
                            let value = getValueInLineOrGia(Number(e.target.value), line);
                            if (!isNaN(value)) {
                                value = getGiaFromLine(value, line)
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, gia2C: value } }))
                            }
                        }}

                        value={getGiaDisplay(state.setGiaThuong.gia2C)}
                    ></InputText>
                    <InputText label="Thưởng"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            if (!isNaN(value))
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, thuong2C: value } }))
                        }}
                        value={state.setGiaThuong.thuong2C}></InputText>
                </div>
                <div className=" common-container-row center grid">
                    <div className=" label-left-of-input">3 con</div>
                    <InputText label={IsRenderLine() ? "Line" : "Giá"}
                        onChange={(e) => {
                            const line = IsRenderLine()
                            let value = getValueInLineOrGia(Number(e.target.value), line);
                            if (!isNaN(value)) {
                                value = getGiaFromLine(value, line)
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, gia3C: value } }))
                            }
                        }}
                        value={getGiaDisplay(state.setGiaThuong.gia3C)}></InputText>
                    <InputText label="Thưởng"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            if (!isNaN(value))
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, thuong3C: value } }))
                        }}
                        value={state.setGiaThuong.thuong3C}></InputText>
                </div>
                <div className=" common-container-row center grid">
                    <div className=" label-left-of-input">4 con</div>
                    <InputText label={IsRenderLine() ? "Line" : "Giá"}
                        onChange={(e) => {
                            const line = IsRenderLine()
                            let value = getValueInLineOrGia(Number(e.target.value), line);
                            if (!isNaN(value)) {
                                value = getGiaFromLine(value, line)
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, gia4C: value } }))
                            }
                        }}
                        value={getGiaDisplay(state.setGiaThuong.gia4C)}></InputText>
                    <InputText label="Thưởng"
                        onChange={(e) => {
                            let value = Number(e.target.value);
                            if (!isNaN(value))
                                setState(prev => ({ ...prev, setGiaThuong: { ...prev.setGiaThuong, thuong4C: value } }))
                        }}
                        value={state.setGiaThuong.thuong4C}></InputText>
                </div>
            </ConfirmDialog >
        </div >
    )
}
export default memo(EditContact)